import { Text, Colors, Inset, Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

type ListMenuType = { disabled: boolean }
type ListIconType = { isComplete: boolean; isActive: boolean }
type ProgressLineType = { isComplete: boolean; isActive: boolean }
export const ListMenu = styled.div`
  cursor: ${(p: ListMenuType) => (p.disabled ? 'default' : 'pointer')};
  display: flex;
  justify-content: space-between;
`

export const ListIcon = styled(Inset)`
  border-radius: 50%;
  width: 35px;
  flex-shrink: 0;
  height: 35px;
  background: ${Colors.SystemWhite};
  border: ${(p: ListIconType) => {
    if (p.isActive) {
      return `2px solid ${Colors.SystemBlack}`
    }
    if (p.isComplete) {
      return `2px solid ${Colors.SystemGrey10}`
    }
    return `2px solid ${Colors.SystemGrey60}`
  }};
  text-align: center;
  margin-top: ${Spacing.XxxSmall}px;
  margin-right: ${Spacing.Small}px;
  position: relative;

  ${Media.Mobile`
    margin-right: ${Spacing.XSmall}px;
  `};
`

export const ProgressLine = styled.hr`
  background-color: ${(p: ProgressLineType) =>
    p.isComplete || !p.isActive ? Colors.SystemGrey10 : Colors.SystemBlack};
  border: none;
  min-width: 2px;
  left: 18px;
  top: 20px;
  position: relative;
`
export const ListTitleContainer = styled.div`
  margin-top: 1px;
  margin-bottom: 1px;
  flex-grow: 1;
`
export const ListMenuContainer = styled.div`
  display: flex;
  &:last-of-type ${ProgressLine} {
    visibility: hidden;
  }
`
export const ContentContainer = styled.div`
  cursor: default;
`

export const BadgeText = styled(Text).attrs<{}>({
  color: Text.Colors.Tertiary,
  size: Text.Sizes.S12,
})`
  font-weight: bold;
`

export const Badge = styled.div`
  background: ${Colors.SystemGrey0};
  height: ${Spacing.Medium}px;
  padding: ${Spacing.XxxxSmall}px ${Spacing.XxSmall}px ${Spacing.XxxxSmall}px
    ${Spacing.XxSmall}px;
  border-radius: ${Spacing.XxSmall}px;
`
